import { useNavigation, useSitemap } from '@msdk/common'
import { ViewItem } from '@msdk/definitions'
import { useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { findIdInSitemap } from 'utils'

export function Legacy() {
  const { tenant, buId, sitemap, contextId } = useParams()
  const location = useLocation()
  const navigate = useNavigation()
  const sitemapModel = useSitemap(sitemap as string)

  // Parse URL. Some routes do not translate directly to the new ones.
  // For example, the Kinexus user view should be translated to the new
  // view with tabs. This is the place to put this kind of specific logic.
  // If no logic matches, the URL from the legacy application is returned.
  // Given that the same entity exists in the model, this should work,
  // but it will need to be tested on a case by case basis.
  const parseUrl = (url: string) => {
    let result = url.replace('/', '')

    if (url === '/USER/HOME_PAGE' || url == '/USER/USER_HOMEPAGE') {
      const item = findIdInSitemap('10.2.1', sitemapModel) as ViewItem
      result = `${item.entity}/${item.viewName}`
    }

    return result
  }

  useEffect(() => {
    // build the base legacy url
    const baseUrl = `/${tenant}/BU/${buId}/${sitemap}/${contextId}`

    // extract the last piece of the route containing the real destination
    const lastPart = location.pathname.replace(baseUrl, '')

    const parsed = parseUrl(lastPart)
    navigate(parsed, sitemap)
  }, [])

  return <></>
}
